import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
	SystemCapabilityEnum,
	SystemCapabilityName,
} from 'src/app/models/data/systemCapability';
import { HasSystemCapabilityDirective } from '../../directives/system-capabilities/has-system-capability.directive';

@Component({
	selector: 'app-not-authorized-notice',
	templateUrl: './not-authorized-notice.component.html',
	styleUrls: [
		'./not-authorized-notice.component.scss',
		'../../ui/common/main.scss',
	],
	encapsulation: ViewEncapsulation.None,
	imports: [HasSystemCapabilityDirective],
})
export class NotAuthorizedNoticeComponent {
	@Input() has?: SystemCapabilityEnum | SystemCapabilityName;
	@Input() hasOne?: (SystemCapabilityEnum | SystemCapabilityName)[];
	@Input() hasAll?: (SystemCapabilityEnum | SystemCapabilityName)[];

	constructor() {}
}
